/**
 * Leaving-site interstitial for external links (currently fda.gov only).
 *
 * Intercepts clicks on matching anchors, shows the modal, and lets the user
 * either continue (opens destination in new tab) or cancel (stays on page).
 */
export function initLeavingSiteModal() {
  const modal = document.querySelector('[data-emc-leaving-modal]');
  if (!modal) return;

  const continueBtn = modal.querySelector('[data-emc-leaving-continue]');
  const closeBtns   = modal.querySelectorAll('[data-emc-leaving-close]');

  // Only intercept fda.gov links anywhere on the page.
  const triggers = document.querySelectorAll('a[href*="fda.gov"]');
  if (!triggers.length) return;

  let lastTrigger = null;

  const open = (destination, triggerEl) => {
    lastTrigger = triggerEl;
    continueBtn.href = destination;
    modal.hidden = false;
    closeBtns[0]?.focus();
  };

  const close = () => {
    modal.hidden = true;
    continueBtn.href = '#';
    lastTrigger?.focus();
    lastTrigger = null;
  };

  triggers.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      open(link.href, link);
    });
  });

  continueBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const dest = continueBtn.href;
    close();
    window.open(dest, '_blank', 'noopener,noreferrer');
  });

  closeBtns.forEach((btn) => {
    if (btn !== continueBtn) {
      btn.addEventListener('click', close);
    }
  });

  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
